module.exports = __webpack_public_path__ + "integration-sentry.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/integration-sentry.png
// module id = 1249
// module chunks = 74